import { useCallback } from 'react'
import { useSelector } from "react-redux"

import LocalPersistence from "utils/localPersistence"
import { TrackType } from "utils/tracking"

const ONBOARDING_EDUCATION_PROPERTY = TrackType.DASHBOARD_ONBOARDING_SHEPHERD_TOUR_DISMISSED
const ADMIN_ONBOARDING_EDUCATION_PROPERTY = 'hasSeenFilterButtonModal'
const ACCOUNT_FIT_EDUCATION_PROPERTY = 'hasSeenAccountFitEducation'

const useEducationState = () => {
    const isCheckListOpen = useSelector((state: any) => state.onboarding.activationChecklistIsOpen)

    const hasFinishedOnboarding = LocalPersistence.get(ONBOARDING_EDUCATION_PROPERTY) || LocalPersistence.get(ADMIN_ONBOARDING_EDUCATION_PROPERTY)
    const setFinishedOnboarding = useCallback(() => LocalPersistence.set(ONBOARDING_EDUCATION_PROPERTY, true), [])

    const hasSeenAccountFitEducation = LocalPersistence.get(ACCOUNT_FIT_EDUCATION_PROPERTY)
    const setSeenAccountFitEducation = useCallback(() => LocalPersistence.set(ACCOUNT_FIT_EDUCATION_PROPERTY, true), [])

    return {
        isCheckListOpen,
        hasFinishedOnboarding,
        setFinishedOnboarding,
        hasSeenAccountFitEducation,
        setSeenAccountFitEducation
    }
}

export default useEducationState